export default class Route {
  constructor() {
    this.start_date = "";
    this.start_time = "";
    this.end_date = "";
    this.end_time = "";
    this.sequence_index = 0;
    this.is_return_route = false;
    this.start_place_id = "";
    this.start_place_name = "";
    this.end_place_id = "";
    this.end_place_name = "";
  }

  loadFromApiData(apiData) {
    this.start_date = apiData.departure_date;
    this.start_time = apiData.departure_time;
    this.end_date = apiData.arrival_date;
    this.end_time = apiData.arrival_time;
    this.sequence_index = apiData.sequence_index;
    this.is_return_route = apiData.is_return_route;
    this.start_place_id = apiData.departure_place_id;
    this.start_place_name = apiData.departure_place_name;
    this.end_place_id = apiData.arrival_place_id;
    this.end_place_name = apiData.arrival_place_name;
  }
}
